export default __webpack_public_path__ + "static/logo_all_white-4f65adfc79c870cbc03a1970ec839e2b.svg";